import type React from 'react';

export interface NavbarButtonGroupProps {
  children: React.ReactNode;
}

export const NavbarButtonGroup = ({ children }: NavbarButtonGroupProps) => {
  return (
    <div className="flex gap-2.5 items-center justify-center">{children}</div>
  );
};
